import * as Mod1 from "./discourse/admin-rss-polling-plugin-route-map";
import * as Mod2 from "./discourse/initializers/rss-polling-admin-plugin-configuration-nav";
const compatModules = {
  "discourse/admin-rss-polling-plugin-route-map": Mod1,
  "discourse/initializers/rss-polling-admin-plugin-configuration-nav": Mod2,
};
export default compatModules;
